import React from 'react';
import { connect } from 'react-redux';
import i18n from '../../../i18n/i18n';
import { Button, IconButton } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import Grid from "@material-ui/core/Grid";
import { SketchPicker } from 'react-color';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { setInitialState, addCropSubgroup, getGroup } from '../../../actions/resources/CropActions';
import Modal from '@material-ui/core/Modal';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
export class AddCropSubgroup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            cropSubgroupObj: this.props.cropSubgroupObj,
            displayColorPicker: false,
            openModal: false,
        }
    }

    componentDidMount() {
        if (this.props.cropGroupDropdown.length === 0) {
            this.props.getGroup();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.cropSubgroupPostingFailed === true) {
            toast.error(i18n.t('Something went wrong, please try again!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80
            });
            this.props.setInitialState('cropSubgroupPostingFailed');
        }
    }


    addCropSubgroup() {
        if (this.state.cropSubgroupObj.naziv
            && this.state.cropSubgroupObj.id_kultura_grupa) {
            this.props.addCropSubgroup(
                this.state.cropSubgroupObj
            )

        } else {
            toast.error(i18n.t('Please enter all required fields!'), {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                draggablePercent: 80

            });
        }
    }


    handleChangeValue = name => event => {
        let obj = Object.assign({}, this.state.cropSubgroupObj);
        obj[name] = event.target.value;
        this.setState({ cropSubgroupObj: obj });
    };

    handleChangeComplete = (color) => {
        let obj = Object.assign({}, this.state.cropSubgroupObj);
        obj.boja = color.hex;
        this.setState({ cropSubgroupObj: obj });
    };

    handleClick = () => {
        this.setState({ displayColorPicker: !this.state.displayColorPicker, openModal: !this.state.openModal })
    };

    handleClose = () => {
        this.setState({ displayColorPicker: false, openModal: false })
    };



    render() {
        let group = [];
        if (this.props.cropGroupDropdown && !this.props.groupFetching) {
            group = this.props.cropGroupDropdown.map((s, i) => {
                return <option key={s.id} value={s.id}>{s.naziv}</option>
            });
        }
        return (
            <div style={{ padding: 20 }}>

                {/* <Paper className="roundedBoxMaterial" zdepth={4}> */}
                <Dialog
                    open={this.props.add}
                    onClose={this.props.handleClose}
                    disableBackdropClick
                    maxWidth="xs"
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle disableTypography={true} className="responsive-dialog-title">{this.props.edit ? i18n.t('Edit crop subgroup') : i18n.t('Add crop subgroup')}
                        <IconButton onClick={this.props.handleClose}>
                            <span className="icon-cancel-circle closeIcon" />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent>
                        <form id="add-crop-subgroup">
                            <Grid container justify="space-between" alignContent="space-between" spacing={16}>
                                <Grid item>
                                    <TextField
                                        select
                                        label={i18n.t('Group')}
                                        value={this.state.cropSubgroupObj.id_kultura_grupa}
                                        onChange={this.handleChangeValue('id_kultura_grupa')}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        required
                                        margin="normal"
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                    >
                                        <option value='' />
                                        {group}
                                    </TextField>
                                </Grid>
                                <Grid item>
                                    <TextField
                                        required
                                        label={i18n.t('Title')}
                                        value={this.state.cropSubgroupObj.naziv}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('naziv')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Parcel color')}
                                        value={this.state.cropSubgroupObj.boja_table}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('boja_table')}

                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Icon name')}
                                        value={this.state.cropSubgroupObj.ime_ikonice}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('ime_ikonice')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('Priority')}
                                        value={this.state.cropSubgroupObj.prioritet}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px' }}
                                        onChange={this.handleChangeValue('prioritet')}
                                    />
                                </Grid>
                                <Grid item >
                                    <TextField
                                        label={i18n.t('color')}
                                        style={{ width: '256px', marginTop: '10px', marginBottom: '10px', backgroundColor: this.state.cropSubgroupObj.boja && this.state.cropSubgroupObj.boja.includes('#') ? `${this.state.cropSubgroupObj.boja}` : `#${this.state.cropSubgroupObj.boja}` }}
                                        onClick={this.handleClick}
                                        value={this.state.cropSubgroupObj.boja}
                                    >
                                    </TextField>
                                    {this.state.displayColorPicker ? <div style={{
                                        position: 'absolute',
                                        zIndex: '2',
                                    }}>
                                        <Modal
                                            aria-labelledby="simple-modal-title"
                                            aria-describedby="simple-modal-description"
                                            open={this.state.openModal}
                                            onClose={this.handleClose}
                                            style={{
                                                position: 'absolute',
                                                left: '50%',
                                                top: '50%',
                                                right: '50%',
                                                bottom: '50%',
                                            }}
                                        >
                                            <SketchPicker color={this.state.cropSubgroupObj.boja != null ? this.state.cropSubgroupObj.boja : ''} onChange={this.handleChangeComplete} />
                                        </Modal>
                                    </div> : null}
                                </Grid>
                                <Grid item xs>
                                    <Button
                                        style={{ alignSelf: 'center', backgroundColor: '#58B4E5', color: 'white' }}
                                        onClick={() => this.addCropSubgroup()}
                                    >
                                        {this.props.edit ? i18n.t('Save') : i18n.t('Add')}
                                    </Button>
                                </Grid>
                                <Grid item xs={3}>
                                </Grid>
                            </Grid>
                        </form>
                    </DialogContent>
                </Dialog>
                {/* </Paper> */}
            </div >

        )
    }
};

function mapStateToProps(state) {
    return {
        cropGroupDropdown: state.cropReducer.cropGroupDropdown,
        groupFetching: state.cropReducer.groupFetching,
        cropSubgroupObj: state.cropReducer.cropSubgroupObj,
        groupFetchingFailed: state.cropReducer.groupFetchingFailed,
        cropSubgroupPosting: state.cropReducer.cropSubgroupPosting,
        cropSubgroupPostingFailed: state.cropReducer.cropSubgroupPostingFailed
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getGroup: () => dispatch(getGroup()),
        setInitialState: (component) => dispatch(setInitialState(component)),
        addCropSubgroup: (cropSubgroupObj) => dispatch(addCropSubgroup(cropSubgroupObj)),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddCropSubgroup)